import { doc } from "firebase/firestore";
import { firestore } from "../../../firebase/firebase";
import issuePaths from "../../../firebase/issues/issuesPaths";

const getIssueRef = (issueId) => {
  const issuePath = `${issuePaths.issues}/${issueId}`;
  return doc(firestore, issuePath);
}

export default getIssueRef;